import React from 'react';
import SafeIcon from '../common/SafeIcon';

const Settings = () => {
  return (
    <div className="space-y-6 max-w-4xl mx-auto">
      <div className="mb-8">
        <h2 className="text-2xl font-bold text-ice">System Config</h2>
        <p className="text-sm text-slate-400 font-mono mt-1">WORKSPACE PREFERENCES</p>
      </div>

      <div className="grid gap-6">
        {/* Profile Settings */}
        <div className="glass-panel p-6 rounded-xl border border-slate-800">
          <h3 className="text-lg font-semibold text-ice mb-4 flex items-center">
            <SafeIcon name="User" className="mr-2 text-slate-400" /> Commander Profile
          </h3>
          <div className="space-y-4">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div>
                <label className="block text-xs font-mono text-slate-500 mb-1">CALLSIGN (NAME)</label>
                <input type="text" defaultValue="Alex Vance" className="w-full bg-slate-900 border border-slate-700 rounded px-3 py-2 text-sm text-ice focus:border-rocket-500 focus:outline-none" />
              </div>
              <div>
                <label className="block text-xs font-mono text-slate-500 mb-1">COMMS LINK (EMAIL)</label>
                <input type="email" defaultValue="alex@diglab.ai" className="w-full bg-slate-900 border border-slate-700 rounded px-3 py-2 text-sm text-ice focus:border-rocket-500 focus:outline-none" />
              </div>
            </div>
            <button className="bg-slate-800 hover:bg-slate-700 text-ice px-4 py-2 rounded text-sm transition-colors border border-slate-700">
              Update Credentials
            </button>
          </div>
        </div>

        {/* Notification Preferences */}
        <div className="glass-panel p-6 rounded-xl border border-slate-800">
          <h3 className="text-lg font-semibold text-ice mb-4 flex items-center">
            <SafeIcon name="Bell" className="mr-2 text-slate-400" /> Telemetry Alerts
          </h3>
          <div className="space-y-3">
            {[
              { id: 'n1', label: 'Stage Gate Approvals', desc: 'Notify when a phase requires sign-off', active: true },
              { id: 'n2', label: 'Asset Uploads', desc: 'Alert when new payload arrives in Asset Room', active: true },
              { id: 'n3', label: 'Risk Escalation', desc: 'Immediate ping on High-level risk flags', active: true },
              { id: 'n4', label: 'Daily Mission Brief', desc: 'Morning summary of timeline drift', active: false },
            ].map(setting => (
              <div key={setting.id} className="flex items-center justify-between p-3 bg-slate-900/50 rounded border border-slate-800">
                <div>
                  <p className="text-sm font-medium text-ice">{setting.label}</p>
                  <p className="text-xs text-slate-500">{setting.desc}</p>
                </div>
                <button className={`w-10 h-5 rounded-full relative transition-colors ${setting.active ? 'bg-rocket-500' : 'bg-slate-700'}`}>
                  <span className={`absolute top-0.5 left-0.5 w-4 h-4 bg-white rounded-full transition-transform ${setting.active ? 'translate-x-5' : 'translate-x-0'}`} />
                </button>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Settings;